import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage } from '~/components/admin/overview-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/')({
  head: () => ({ meta: [{ title: `${m.admin_title()} – ${m.app_name()}` }] }),
  component: AdminRoute,
})

function AdminRoute() {
  return (
    <>
      <PageHeader title={m.admin_title()} description={m.admin_description()} />
      <OverviewPage />
    </>
  )
}
